import React from "react";
import {
  QueryTVEnergyData,
  SubscribeTVEnergyData,
  QueryTVEnergyConnectionState,
  SubscribeTVEnergyConnectionState,
  SubscribeResetTvEnergyData,
} from "../../../utils/graphql/hooks/TVEnergyHooks";

export default function TvEnergyDataManager() {
  QueryTVEnergyData();
  SubscribeTVEnergyData();
  QueryTVEnergyConnectionState();
  SubscribeTVEnergyConnectionState();
  SubscribeResetTvEnergyData();
  return <></>;
}
